import config from '@/config'
import { AppType } from '@repo/backend/app'
import { AUTHORIZATION_HEADER_PREFIX } from '@repo/constants'
import { hc } from 'hono/client'
import { atom } from 'jotai'
import { store } from '.'
import { sessionTokenAtom } from './session'

const fetchWithThrow = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
  const res = await fetch(input, init)
  if (!res.ok) {
    const contentType = res.headers.get('Content-Type')
    if (contentType && contentType.includes('application/json')) {
      const json = await res.json()
      throw new Error(json.message ?? 'Request failed')
    }
    throw new Error(`Request failed with status ${res.status}`)
  }
  return res
}

export type HonoClient = ReturnType<typeof createHonoClient>

export const createHonoClient = (sessionToken: string | null) => {
  if (sessionToken) {
    return hc<AppType>(config.backendURL, {
      headers: {
        Authorization: `${AUTHORIZATION_HEADER_PREFIX}${sessionToken}`,
      },
      fetch: fetchWithThrow,
    })
  }

  return hc<AppType>(config.backendURL)
}

const apiAtom = atom((get) => {
  const token = get(sessionTokenAtom)
  return createHonoClient(token)
})

export const getApi = () => store.get(apiAtom)
